import {
  AudioLines,
  Captions,
  Clapperboard,
  FileText,
  Layers,
  Languages,
  ListTree,
  MicVocal,
  Scissors,
  Type,
  UsersRound,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  hint: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: readonly NavGroup[] = [
  {
    label: 'Библиотеки',
    items: [
      {
        to: '/library',
        label: 'Вставки',
        icon: Layers,
        hint: 'Видео и фото для перебивок',
      },
      {
        to: '/characters',
        label: 'Персонажи',
        icon: UsersRound,
        hint: 'Актёры, от лица которых делается контент',
      },
      {
        to: '/voices',
        label: 'Клонирование голоса',
        icon: AudioLines,
        hint: 'Свои клоны и библиотека ElevenLabs',
      },
      {
        to: '/prompts',
        label: 'Промты',
        icon: FileText,
        hint: 'Общая база готовых промптов',
      },
      {
        to: '/fonts',
        label: 'Шрифты',
        icon: Type,
        hint: 'Шрифты команд для монтажа',
      },
    ],
  },
  {
    label: 'Инструменты',
    items: [
      {
        to: '/tts',
        label: 'Озвучка',
        icon: MicVocal,
        hint: 'Текст в речь голосом из библиотеки',
      },
      {
        to: '/placement',
        label: 'Расстановка',
        icon: ListTree,
        hint: 'Где в ролике показать вставки',
      },
      {
        to: '/translate',
        label: 'Транслейт',
        icon: Languages,
        hint: 'Русские субтитры к чужому ролику',
      },
      {
        to: '/subtitles',
        label: 'Субтитры',
        icon: Captions,
        hint: 'Вжечь субтитры в пачку роликов',
      },
      {
        to: '/video-gen',
        label: 'Генерация видео',
        icon: Clapperboard,
        hint: 'Спикер из фото или анимация фото',
      },
    ],
  },
  {
    label: 'Липсинк',
    items: [
      {
        to: '/cut',
        label: 'Нарезка под липсинк',
        icon: Scissors,
        hint: 'Куски, где человек смотрит в камеру',
      },
    ],
  },
];

export const NAV_ITEMS: readonly NavItem[] = NAV_GROUPS.flatMap((group) => group.items);

const EXTRA_LABELS: Readonly<Record<string, string>> = {
  admin: 'Администрирование',
  jobs: 'Задания',
  brief: 'Мастер создания',
  adapt: 'Мастер адаптации',
  libraries: 'Библиотеки',
};

export function findNavItem(pathname: string): NavItem | undefined {
  return NAV_ITEMS.find((item) => pathname === item.to || pathname.startsWith(`${item.to}/`));
}

export function sectionLabel(pathname: string): string {
  const item = findNavItem(pathname);
  if (item) return item.label;
  const segment = pathname.split('/').filter(Boolean)[0] ?? '';
  return EXTRA_LABELS[segment] ?? 'Раздел';
}

export function sectionHint(pathname: string): string | undefined {
  return findNavItem(pathname)?.hint;
}
